import { Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { ToastInfo } from '../../models/toast-info';
import { LoggingService } from '../../services/logging.service';
import { TOAST_CONSTANTS } from '../../../constants/toast.constants';

@Component({
  selector: 'adf-toast',
  standalone: true,
  imports: [CommonModule, NgbToastModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  private readonly _loggingService = inject(LoggingService);

  toasts = this._loggingService.getToasts();
  readonly defaultDelay = TOAST_CONSTANTS.DEFAULT_DELAY;

  removeToast(toast: ToastInfo) {
    this._loggingService.remove(toast);
  }
}
